import { END_POINT } from "../constants";
import { HTTP } from "./http";

export const RolService = {

    getRoles: () => {
        return HTTP.get<any, any>(`${END_POINT}roles`);
    },
}